import React from "react";
import amplifyAI from "../../assets/images/AmplifyAI.png";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import logotft from "../../assets/images/logotft.png";
import "../style.css";

const LandingPage = () => {
  const { signupData, setSignupData, signupDataSession, setSignupDataSession } =
    React.useContext(SchoolSignupContext);

  const navigate = useNavigate();

  const handleSchoolType = (type) => () => {
    navigate("/school", { state: { fromLanding: true } });
    setSignupData({
      ...signupData,
      schoolType: type,
    });
    setSignupDataSession({
      ...signupDataSession,
      schoolType: type,
    });
  };

  return (
    <>
      <div className="tft-front-page">
        <h2 className="mb-4">Choose Your Organization</h2>
        <div className="organisaton-container">
          <div className="choose-organisaton">
            <div className="choose-organisaton-img">
              <img src={amplifyAI} alt="Amplify-AI" />
            </div>
            <div className="organisation-text-info">
              <p>
              Empowering educators through smarter planning tools, faster IEP drafts, and better outcomes for every student.
              </p>
            </div>
            <button
              type="button"
              className="btn border"
              onClick={handleSchoolType(2)}
            >
              Enter <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>

          <div className="choose-organisaton choose-organisaton-coming-soon">
            <div className="choose-organisaton-img organisation-imag-inne">
              <div>
                <img src={logotft} alt="Teaching for Transformation" />
              </div>
              <div className="wam-coming3d-wrap">
                <h3 className="wam-coming3d-text">Coming Soon</h3>
              </div>
            </div>
            <div className="organisation-text-info">
              <p>
                The Deep Hope of Teaching for Transformation is to invite,
                nurture, and empower learners to live restoratively within God's
                story of redemption through deeper learning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
